require('es6-promise').polyfill()
require('promise.prototype.finally').shim()
// chrome 47 以下
require('core-js/fn/array/includes')
